import { OListItemDirective } from '../components/list/list-item/o-list-item.directive';

export const ONTIMIZE_DIRECTIVES = [
  //Ontimize directives...
  OListItemDirective
];
